export const errorCodes = {
  INCORRECT_LOGIN: 1,
  ENTER_VALID: 2,
  TOO_MANY_ATTEMPTS: 3,
  PASSWORDS_DO_NOT_MATCH: 4,
  FILL_ALL_FIELDS: 5,
  MAX_CHARACTER_LIMIT: 6,
  FIELD_REQUIRED: 7,
  PLEASE_SELECT_OPTION: 8,
  NAME_ALREADY_EXISTS: 9,
  NEW_PASSWORD_MUST_BE_DIFFERENT: 11,
  CURRENT_PASSWORD_IS_INCORRECT: 12,
  DOB_NOT_VALID: 18,
  ALL_FIELDS_MUST_BE_POPULATED: 19,
  CANNOT_SELECT_PERIOD_MORE_THAN_30_DAYS: 20,
  ACCOUNT_ON_HOLD: 21,
  THIS_PHONE_NUMBER_CONNOT_BE_USED: 22,
  PLEASE_SAVE_GENERAL_INFO_BEFORE: 23,
  PASSWORD_RESET_REQUIRED: 25,
  PASSWORD_DETECTED_IN_BREACH: 26,
  PASSWORD_NOT_VALID: 27,
  TOKEN_NOT_VALID: 28,
  EMAIL_UNDELIVERABLE: 29,
  EMAIL_NOT_UNIQUE: 30,
  TOO_MANY_REQUESTS: 105,
  NOT_VERIFY: 107,
  PHONE_NUMBER_CONNOT_MATCH_YOUR_OWN: 108,
  PHONE_NUMBER_CONNOT_BE_AS_EMERGENCY: 111,
  CANNOT_RESHEDULE_VISIT: 122,
  ACTION_BLOCKED: 123,
  BIG_VALUE: 201,
  ALREADY_ACTIVATED_USER: 207,
  LICENSE_INVALID: 208,
  INVALID_FILE_FORMAT: 209,
  TOO_BIG_FILE_SIZE: 210,
  DUPLICATE_LICENSES_FROM_SERVER: 211,
  INPUT_VALUE_HIGHER_THAN_VALUE: 212,
  DUPLICATE_LICENSES: 214,
  CANNOT_SAVE_NEGATIVE_BALANCE: 215,
  DUPLICATE_OPTIONS: 216,
  NON_NEGATIVE_NUMBER: 217,
  CANNOT_ALTER_SCHEDULE: 219,
  INVALID_VISIT_TIME: 220,
  SELECT_PATIENT_REQUIRED: 221,
  CREDIT_CARD_MISSING: 222,
  UNABLE_TO_BOOK_WITH_PROVIDER: 615,
  PATIENT_CREDIT_AMOUNT_CHANGED: 224,
  SET_ONE_VISIBILITY_AS_ALL_OR_NEW: 225,
  PROVIDER_NUMBER_NOT_UNIQUE: 218,
  CANNOT_MANUALLY_OVERRIDE: 226,
  OVERLAPPING_SCHEDULE: 302,
  CANT_SAVE_PAST_DATE: 303,
  END_BEFORE_START: 304,
  MORE_THAN_24_HOURS_EVENT: 305,
  REPEAT_TIME_AFTER_END: 308,
  ONLY_NUMBERS_AND_LETTERS_ALLOWED: 316,
  NEED_AT_LEAST_ONE_QUESTION: 613,
  NEED_SAVE_AT_LEAST_ONE_QUESTION: 614,
  LICENSE_WITHOUT_ONE_SERVICE_TYPE: 307,
  NOT_VALID_VALUE: 400,
  CAN_NOT_SELECT_VISIT_TIME: 602,
  MUST_ADD_CREDIT_CARD_TOAST: 605,
  CANNOT_CANCEL_VISIT: 610,
  NOT_FOUND: 404,
  ALLERGY_NAME_NOT_UNIQUE: 409,
  NO_CONNECTION: 501,
  TIMEOUT: 512,
  DEFAULT: 500,
  ITEM_DOES_NOT_EXIST: 601,
  CANNOT_BOOK_VISIT: 615,
  DOES_NOT_EXIST_NO_REFRESH: 619,
  DUPLICATE_CREDIT_CARD: 626,
  FORBIDDEN_ACTION: 624,
  RESCHEDULE_WITH_ORIGINAL_DATE_TIME: 627,
  NO_PERMISSION_TO_DELETE_FILE: 628,
  TREATMENT_CENTER_NOT_AVAILABLE: 629,
}

export const DEFAULT = 500

/**
 * @param {number|string} [code] Numeric error code or server UserFriendlyErrorCode.
 * @param {string|null} [message]
 * @param {string|null} [extra]
 * @returns {string}
 */
export function getUserFriendlyErrorMessage(
  code: string | number = DEFAULT,
  message: string | null = '',
  extra: string | null = '',
) {
  let messageCopy = message
  if (!message) {
    switch (code) {
      case errorCodes.DOES_NOT_EXIST_NO_REFRESH:
        messageCopy = `Requested ${extra} does not exist.`
        break
      case errorCodes.ACCOUNT_ON_HOLD:
        messageCopy = `This account has been put on hold. Please contact support.`
        break
      case errorCodes.FORBIDDEN_ACTION:
        messageCopy = 'You are not allowed to update this record.'
        break
      case errorCodes.NO_PERMISSION_TO_DELETE_FILE:
        messageCopy = "You don't have permission to delete this file."
        break
      case errorCodes.PATIENT_CREDIT_AMOUNT_CHANGED:
        messageCopy = `The credit amount on the patient's account has changed. Please review the updated payment information before completing the booking.`
        break
      case errorCodes.CANNOT_MANUALLY_OVERRIDE:
        messageCopy = `Can not override this patient's ID verification.`
        break
      case errorCodes.SET_ONE_VISIBILITY_AS_ALL_OR_NEW:
        messageCopy = `Set one visit type to All patients/New patients only.`
        break
      case errorCodes.ENTER_VALID:
        messageCopy = `Please enter a valid ${extra}.`
        break
      case errorCodes.PROVIDER_NUMBER_NOT_UNIQUE:
        messageCopy = `This number is already associated with a provider.`
        break
      case errorCodes.OVERLAPPING_SCHEDULE:
        messageCopy = `Cannot save overlapping ${extra} block.`
        break
      case errorCodes.DUPLICATE_CREDIT_CARD:
        messageCopy = `This credit card is already added. Please try another credit card.`
        break
      case errorCodes.UNABLE_TO_BOOK_WITH_PROVIDER:
        messageCopy = 'Cannot book a visit with this provider.'
        break
      case errorCodes.INVALID_FILE_FORMAT:
        messageCopy = `Please select file in the correct format: ${extra}.`
        break
      case errorCodes.CANNOT_ALTER_SCHEDULE:
        messageCopy = `Can not alter past schedule.`
        break
      case errorCodes.TOO_BIG_FILE_SIZE:
        messageCopy = `Cannot upload file that is bigger than ${extra}.`
        break
      case errorCodes.SELECT_PATIENT_REQUIRED:
        messageCopy = `Selecting a patient is required.`
        break
      case errorCodes.CANNOT_CANCEL_VISIT:
        messageCopy = `You cannot reschedule this visit.`
        break
      case errorCodes.LICENSE_INVALID:
        messageCopy = `Use: A-z, 0-9, '.', ' ', '-'.`
        break
      case errorCodes.MUST_ADD_CREDIT_CARD_TOAST:
        messageCopy = 'You must add a form of payment to book your visit.'
        break
      case errorCodes.CREDIT_CARD_MISSING:
        messageCopy = 'Please enter a payment method.'
        break
      case errorCodes.REPEAT_TIME_AFTER_END:
        messageCopy = `Date cannot be before End date.`
        break
      case errorCodes.NOT_VERIFY:
        messageCopy = `The email associated with this account has not been verified.`
        break
      case errorCodes.PHONE_NUMBER_CONNOT_MATCH_YOUR_OWN:
        messageCopy = `Phone number cannot match your own.`
        break
      case errorCodes.PHONE_NUMBER_CONNOT_BE_AS_EMERGENCY:
        messageCopy = `Phone cannot match emergency contact.`
        break
      case errorCodes.END_BEFORE_START:
        messageCopy = `Cannot save ${extra} that starts after the end date and time.`
        break
      case errorCodes.DUPLICATE_LICENSES:
        messageCopy = `Duplicate License.`
        break
      case errorCodes.CANT_SAVE_PAST_DATE:
        messageCopy = `Cannot save ${extra} that starts in the past.`
        break
      case errorCodes.CANNOT_SAVE_NEGATIVE_BALANCE:
        messageCopy = `Cannot save negative visit credit balance.`
        break
      case errorCodes.NEED_AT_LEAST_ONE_QUESTION:
        messageCopy = `Cannot create intake form without any question.`
        break
      case errorCodes.DUPLICATE_OPTIONS:
        messageCopy = 'Cannot use duplicate options.'
        break
      case errorCodes.NON_NEGATIVE_NUMBER:
        messageCopy = 'Valid input: Non-negative number.'
        break
      case errorCodes.NEED_SAVE_AT_LEAST_ONE_QUESTION:
        messageCopy = 'Cannot create intake form with unsaved question(s).'
        break
      case errorCodes.DUPLICATE_LICENSES_FROM_SERVER:
        messageCopy = `Shared License.`
        break
      case errorCodes.INPUT_VALUE_HIGHER_THAN_VALUE:
        messageCopy = `Please input a number equal or lower than ${extra}.`
        break
      case errorCodes.LICENSE_WITHOUT_ONE_SERVICE_TYPE:
        messageCopy = `At least one visit type required.`
        break
      case errorCodes.BIG_VALUE:
        messageCopy = `Please input a number equal or lower than ${extra}.`
        break
      case errorCodes.MORE_THAN_24_HOURS_EVENT:
        messageCopy = `Cannot save ${extra} block that is longer than 24 hrs.`
        break
      case errorCodes.ONLY_NUMBERS_AND_LETTERS_ALLOWED:
        messageCopy = 'Only numbers and letters are allowed.'
        break
      case errorCodes.ALREADY_ACTIVATED_USER:
        messageCopy = `Cannot change the email address for an activated user.`
        break
      case errorCodes.PASSWORDS_DO_NOT_MATCH:
        messageCopy = 'Passwords do not match.'
        break
      case errorCodes.MAX_CHARACTER_LIMIT:
        messageCopy = 'Max character limit exceeded.'
        break
      case errorCodes.FIELD_REQUIRED:
        messageCopy = `${extra} is a required field.`
        break
      case errorCodes.PLEASE_SELECT_OPTION:
        messageCopy = 'Please select an option.'
        break
      case errorCodes.NAME_ALREADY_EXISTS:
        messageCopy = `${extra} already exists.`
        break
      case errorCodes.ITEM_DOES_NOT_EXIST:
        messageCopy = `Requested ${extra} does not exist. Please refresh your screen.`
        break
      case errorCodes.CANNOT_BOOK_VISIT:
        messageCopy = `Cannot book a visit with this provider.`
        break
      case errorCodes.NEW_PASSWORD_MUST_BE_DIFFERENT:
        messageCopy = `New password must be different.`
        break
      case errorCodes.CURRENT_PASSWORD_IS_INCORRECT:
        messageCopy = 'Current password is incorrect.'
        break
      case errorCodes.DOB_NOT_VALID:
        messageCopy = 'DOB must be between 01/01/1901 and the present date.'
        break
      case errorCodes.ALL_FIELDS_MUST_BE_POPULATED:
        messageCopy = `All fields in ${extra} must be populated.`
        break
      case errorCodes.CANNOT_SELECT_PERIOD_MORE_THAN_30_DAYS:
        messageCopy = `Cannot select time period longer than 30 days.`
        break
      case errorCodes.THIS_PHONE_NUMBER_CONNOT_BE_USED:
        messageCopy = `This phone number cannot be used at this time.`
        break
      case errorCodes.PLEASE_SAVE_GENERAL_INFO_BEFORE:
        messageCopy = `Please save General information first and then Account information.`
        break
      case errorCodes.TIMEOUT:
        messageCopy = 'Server Response Timeout. Please try again.'
        break
      case errorCodes.INCORRECT_LOGIN:
        messageCopy = 'You entered an incorrect email or password.'
        break
      case errorCodes.INVALID_VISIT_TIME:
        messageCopy = `Cannot book a visit in the past.`
        break
      case errorCodes.CAN_NOT_SELECT_VISIT_TIME:
        messageCopy = `Unable to select this visit time. Please select a different time.`
        break
      case errorCodes.TREATMENT_CENTER_NOT_AVAILABLE:
        messageCopy = `This provider is not available at the visit's location at the selected time. Please select a different time.`
        break
      case errorCodes.NOT_FOUND:
        messageCopy = `${extra} with sent identifier is not found.`
        break
      case errorCodes.NOT_VALID_VALUE:
        messageCopy = `${extra} is null or not valid`
        break
      case errorCodes.ALLERGY_NAME_NOT_UNIQUE:
        messageCopy = `Same allergy record already exists.`
        break
      case errorCodes.NO_CONNECTION:
        messageCopy = 'No internet connection detected. Please try again.'
        break
      case errorCodes.TOO_MANY_ATTEMPTS:
        messageCopy = 'Too many failed login attempts. Please try again later.'
        break
      case errorCodes.FILL_ALL_FIELDS:
        messageCopy = 'Please complete all requirements.'
        break
      case errorCodes.RESCHEDULE_WITH_ORIGINAL_DATE_TIME:
        messageCopy = 'You are trying to continue rescheduling with the original date and time of the visit.'
        break
      case errorCodes.DEFAULT:
        messageCopy = 'Internal Server Error. Please contact support.'
        break
      case errorCodes.CANNOT_RESHEDULE_VISIT:
        messageCopy = 'You  cannot reschedule this visit.'
        break
      case errorCodes.PASSWORD_DETECTED_IN_BREACH:
        messageCopy = 'Your password was detected in a breach. Please change your password.'
        break
      case errorCodes.PASSWORD_RESET_REQUIRED:
        messageCopy = 'Your password is not valid. Please change your password.'
        break
      case errorCodes.PASSWORD_NOT_VALID:
        messageCopy = 'You have entered an invalid password.'
        break
      case errorCodes.TOKEN_NOT_VALID:
        messageCopy = 'Token not valid. Please try again later.'
        break
      case errorCodes.EMAIL_UNDELIVERABLE:
        messageCopy = 'There was an error sending the email.'
        break
      case errorCodes.EMAIL_NOT_UNIQUE:
        messageCopy = 'This email has already been used.'
        break
      case errorCodes.TOO_MANY_REQUESTS:
        messageCopy = 'Too many requests. Please contact support.'
        break
      case errorCodes.ACTION_BLOCKED:
        messageCopy = `There was an error logging in on this device. Please contact support.`
        break
      default:
        messageCopy = 'Internal Server Error. Please contact support.'
    }
  }
  return `${code} - ${messageCopy}`
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getAPIErrorMessage(errorCode) {
  const mapping = {
    AccountNotVerified: getUserFriendlyErrorMessage(errorCodes.NOT_VERIFY),
    AccountNotActive: getUserFriendlyErrorMessage(errorCodes.ACCOUNT_ON_HOLD),
    EmailNotValid: getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'email'),
    PasswordResetRequired: getUserFriendlyErrorMessage(errorCodes.PASSWORD_RESET_REQUIRED),
    PasswordDetectedInBreach: getUserFriendlyErrorMessage(errorCodes.PASSWORD_DETECTED_IN_BREACH),
    TooManyRequests: getUserFriendlyErrorMessage(errorCodes.TOO_MANY_REQUESTS),
    CredentialsNotValid: getUserFriendlyErrorMessage(errorCodes.INCORRECT_LOGIN),
    PasswordNotValid: getUserFriendlyErrorMessage(errorCodes.PASSWORD_NOT_VALID),
    AccountLocked: getUserFriendlyErrorMessage(errorCodes.TOO_MANY_ATTEMPTS),
    TokenNotValid: getUserFriendlyErrorMessage(errorCodes.TOKEN_NOT_VALID),
    EmailUndeliverable: getUserFriendlyErrorMessage(errorCodes.EMAIL_UNDELIVERABLE),
    EmailNotUnique: getUserFriendlyErrorMessage(errorCodes.EMAIL_NOT_UNIQUE),
    DuplicatePassword: getUserFriendlyErrorMessage(errorCodes.NEW_PASSWORD_MUST_BE_DIFFERENT),
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    InternalServerError: getUserFriendlyErrorMessage(errorCodes.INTERNAL_SERVER_ERROR),
    ActionBlocked: getUserFriendlyErrorMessage(errorCodes.ACTION_BLOCKED),
  }

  // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
  return mapping[errorCode] || getUserFriendlyErrorMessage(errorCodes.INTERNAL_SERVER_ERROR)
}
